import { formatBooleanValue } from "../../util";
import Organisation from "../model/Organisation";

const OrganisationMapper = (item: any) => {
  let organisation = Organisation(item);
  organisation.valid = formatBooleanValue(item.valid);
  return organisation;
};

export default OrganisationMapper;
